import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Admision.css";

//Banners de imágenes
import banner1 from "../assets/admision_matricula/admision/admision1.jpg";
import banner2 from "../assets/admision_matricula/admision/admision2.jpg";
import banner3 from "../assets/admision_matricula/admision/admision3.jpg";

const banners = [
  banner1, banner2, banner3
];

const Admision = () => {
  const [index, setIndex] = useState(0);
  const [fullscreenImg, setFullscreenImg] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % banners.length);
    }, 5000);
    return () => clearInterval(id);
  }, []);

  const prev = () => setIndex((i) => (i - 1 + banners.length) % banners.length);
  const next = () => setIndex((i) => (i + 1) % banners.length);

  return (
    <section className="admision-page">
      {/* Banner superior */}
      <div className="info-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Admisión 2025</h1>
          <p className="lead">
            Ven y estudia los Programas de Estudios que tenemos para ti.
          </p>
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container py-5">
        <div className="row align-items-start">
          {/*  Modalidades de admisión */}
          <div className="col-lg-6 col-md-12" data-aos="fade-right">
            <h2 className="section-subtitle mb-4">Modalidades de Admisión</h2>
            <p className="text-muted mb-4">
              El Proceso de Admisión del Instituto de Educación Superior
              Tecnológico Público <strong>“Gilda Ballivián Rosado”</strong>{" "}
              comprende las siguientes modalidades:
            </p>

            <div className="modalidad">
              <h5 className="fw-bold text-primary">a. Ordinaria:</h5>
              <p>Se realiza periódicamente a través de una evaluación
                considerando condiciones de calidad para cubrir el número de
                vacantes de acuerdo al orden de mérito.</p>
            </div>
            <div className="modalidad">
              <h5 className="fw-bold text-primary">b. Por Exoneración:</h5>
              <p>Contempla la Admisión a deportistas calificados, a estudiantes
                talentosos y aquellos que están cumpliendo servicio militar
                voluntario, de conformidad con la normativa vigente.</p>
            </div>
            <div className="modalidad">
              <h5 className="fw-bold text-primary">c. Por Ingreso Extraordinario:</h5>
              <p>Este proceso de admisión se autoriza por el MINEDU y se
                implementa para becas y programas, conforme a la normativa
                de la materia.</p>
            </div>

            
          </div>

          {/* Slider de banners */}
          <div className="col-lg-6 col-md-12 mt-5 mt-lg-0" data-aos="fade-left">
            <div className="adm-banner-slider-container">
              <div className="adm-banner-slider">
                {banners.map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt={`Banner ${i + 1}`}
                    className={i === index ? "active" : ""}
                    onClick={() => setFullscreenImg(src)}
                  />
                ))}
              </div>
              <button className="adm-banner-arrow left" onClick={prev}>&#10094;</button>
              <button className="adm-banner-arrow right" onClick={next}>&#10095;</button>
            </div>
          </div>
        </div>
      </div>

      {/* Imagen fullscreen */}
      {fullscreenImg && (
        <div className="fullscreen-overlay" onClick={() => setFullscreenImg(null)}>
          <img src={fullscreenImg} alt="Ampliado" className="fullscreen-img" />
        </div>
      )}
    </section>
  );
};

export default Admision;
